export default __webpack_public_path__ + "images/arrow_gray-9d5beae65786a62733dbf1377265e6cd.svg";